import React,{useEffect} from 'react'
import {useMediaQuery} from 'react-responsive'
import bioImage from '../assets/images/about-illustration.svg'
import {motion,useAnimation} from 'framer-motion'
import {useInView} from 'react-intersection-observer'

const skills=[
  {
    group:"Full Stack Engineering",
    items:["JavaScript (ES6+)","TypeScript","Node.js","Express.js","NestJS","React","Next.js","REST APIs","GraphQL"]
  },
  {
    group:"Databases & Data Systems",
    items:["PostgreSQL","MongoDB","Redis","Prisma","Schema design","Query optimization","ETL & data validation"]
  },
  {
    group:"Cloud & Delivery",
    items:["AWS (EC2, ECS, RDS, S3)","Docker","Linux","Nginx","CI/CD","PM2","Load balancing"]
  },
  {
    group:"AI & Automation",
    items:["OpenAI API","Claude","Voice AI Agents","Retell AI","API/webhook integrations","Workflow automation","n8n"]
  },
]

const BioData = () => {
    const control = useAnimation();
    const [ref, inView] = useInView();
    const isMobile = useMediaQuery({
        query: '(min-width: 768px)'
      })

      const BioVariant={
        visible:{opacity:1,x:0},
        hidden:{opacity:0,x:'-90px'}
      }

      useEffect(() => {
        if (inView) {
          control.start("visible");
        } else {
          control.start("hidden");
        }
      }, [control, inView]);
  return (
    <>
     {/*===========Bio Data Section==========*/}
     <section className="text-gray-600 body-font" id='about'>
  <div className="container mx-auto md:w-[90%] w-[90%] flex px-5 sm:py-16 py-8 md:flex-row flex-col items-center">
  {isMobile?(
    <div className="lg:w-1/2 sm:w-1/3 w-full md:self-stretch mt-6 sm:mt-0">
    <motion.div
    className="md:sticky md:top-24"
    transition={{type:'spring',stiffness:120,default: { duration: 2 }}}
    ref={ref}
    variants={BioVariant}
    initial="hidden"
     animate={control}
     >
    <img className="object-cover object-center w-full h-full" src={bioImage} alt="team lead and engineer working across the stack" />
    </motion.div>
    </div>
  ):("")}

    <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
      <h1 className="title-font text-5xl mb-4 font-bold text-gray-900">
      About Me
      </h1>
      <div className="w-24 sm:h-1 md:h-2  my-4 rounded-full sm:mt-0 inline-flex bg-gradient-to-r from-yellow-300 to-yellow-400 text-white relative z-10 title-font font-medium text-sm ">
      </div>
      <p className="mb-8 leading-relaxed lg:px-0 md:px-0">
I work across the stack: backend architecture, database performance, cloud infrastructure and long-term product delivery, including B2B platforms and conversational Voice AI agent integrations. At DataZoro I lead engineering delivery for long-term SaaS and data-platform products, from clarifying requirements with stakeholders to code review and production operations.
       </p>
            <div className='w-full flex flex-col md:items-start md:text-left items-center text-center'>
            {skills.map((skill)=>(
            <div className="mb-4" key={skill.group}>
              <h2 className="font-bold text-gray-900 mb-2">{skill.group}</h2>
              <div className="flex flex-wrap gap-2 md:justify-start justify-center">
                {skill.items.map((item)=>(
                <span className="bg-yellow-100 text-gray-800 text-sm rounded-full px-3 py-1" key={item}>{item}</span>
                ))}
              </div>
            </div>
            ))}
            <motion.div whileHover={{ scale: 1.2 }} >

        <a href="https://drive.google.com/file/d/1wkG6GXUIOPWOZK5WEqwbazdg7xEUUsFK/view?usp=sharing" target="_blank" rel='noreferrer' className="inline-flex hover:bg-gradient-to-l bg-gradient-to-r from-[#fde801] to-[yellow] border-0 py-2 mt-4 px-6 focus:outline-none hover:bg-indigo-600 text-lg">Download CV</a>
        </motion.div>
      </div>


    </div>
    {!isMobile?(
    <div className="lg:w-1/2 sm:w-1/3 w-full md:self-stretch mt-6 sm:mt-0">
    <img className="object-cover object-center w-full h-full" src={bioImage} alt="team lead and engineer working across the stack" />
    </div>
  ):("")}
  </div>
</section>
    </>
  )
}

export default BioData
